import { createVNode as _createVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 2,
  class: "bg-gray-50 rounded-lg p-4 print:p-1"
};
const _hoisted_2 = {
  class: "flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4 mb-4"
};
const _hoisted_3 = {
  class: "w-full lg:w-5/12 print:hidden"
};
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col sm:flex-row justify-end lg:justify-end gap-2 w-full lg:w-5/12 print:hidden"
};
const _hoisted_5 = {
  class: "flex flex-col xl:flex-row xl:justify-between xl:items-start gap-4"
};
const _hoisted_6 = {
  class: "py-2 xl:py-4 text-left"
};
const _hoisted_7 = {
  class: "text-sm lg:text-base"
};
const _hoisted_8 = {
  class: "font-weight-500 pl-2 leading-relaxed",
  "data-cy": "summary-total-hours-display"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  class: "font-weight-500 pl-2 leading-relaxed",
  "data-cy": "summary-total-amount-display"
};
const _hoisted_11 = {
  class: "flex flex-col md:flex-row justify-end gap-2 md:gap-4 print:hidden"
};
const _hoisted_12 = {
  class: "flex flex-row items-center gap-2 mb-2 pb-1"
};
const _hoisted_13 = {
  key: 0,
  style: {
    "margin": "4px 12px",
    "border": "0",
    "border-top": "1px solid #e0e0e0"
  }
};
const _hoisted_14 = {
  key: 3
};
const _hoisted_15 = {
  class: "ft-container transparent totals overflow-x-auto"
};
const _hoisted_16 = {
  class: "ft-row show-times min-w-max"
};
const _hoisted_17 = {
  class: "ft-column timekeeper center ng-animate-disabled"
};
const _hoisted_18 = {
  class: "ft-container transparent text-sm pt-4"
};
const _hoisted_19 = {
  class: "flex flex-col gap-1"
};
const _hoisted_20 = {
  class: "text-left"
};
const _hoisted_21 = {
  class: "font-weight-500 pl-2 leading-relaxed block sm:inline",
  "data-cy": "summary-billable-hours"
};
const _hoisted_22 = {
  class: "text-left"
};
const _hoisted_23 = {
  class: "font-weight-500 pl-2 leading-relaxed block sm:inline",
  "data-cy": "summary-non-billable-hours"
};
const _hoisted_24 = {
  class: "text-left"
};
const _hoisted_25 = {
  class: "font-weight-500 pl-2 leading-relaxed block sm:inline",
  "data-cy": "summary-fixed-fee-hours"
};
const _hoisted_26 = {
  class: "text-left"
};
const _hoisted_27 = {
  class: "font-weight-500 pl-2 leading-relaxed block sm:inline",
  "data-cy": "summary-total-hours"
};
const _hoisted_28 = {
  class: "text-left"
};
const _hoisted_29 = {
  class: "font-weight-500 pl-2 leading-relaxed block sm:inline",
  "data-cy": "summary-total-amount"
};
const _hoisted_30 = {
  key: 3,
  class: "rounded-lg empty-state pb-16 text-center px-4"
};
import { storeToRefs } from 'pinia';
import { reactive, watch, computed, ref } from 'vue';
import EntryTable from './EntryTable.vue';
import Loader from '@/components/Loader.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlSearch from '@/components/LlSearch.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import LlCheckbox from '@/components/LlCheckbox.vue';
import { useEntriesStore } from '@/services/useEntriesStore';
import { useBillingTypeLabel } from '@/composables/useBillingTypeLabel';
import useClientsMattersStore from '@/services/useClientsMattersStore';
import { useResponsiveScreen } from '@/composables/useResponsiveScreen';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { useExportUtilities } from '@/composables/useExportUtilities';
import { pluralizeEntryWithCount } from '@/services/utils';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import LlAssignToFixedFeeModal from '@/components/LlAssignToFixedFeeModal.vue';
import BulkActionToolbar from './components/BulkActionToolbar.vue';
import ChangeMatterDialog from '@/components/ChangeMatterDialog.vue';
import { useFixedFeeBulkOperations } from '@/composables/useFixedFeeBulkOperations';
import EventTracker from '@/services/eventTracker';
import { TrackingCategory, TrackingAction, TrackingPageType } from '@/constants/trackingConstants';
const PRINT_PANEL_CLOSE_DELAY_MS = 600; // Delay to allow panels to close and layout to stabilize
const PRINT_FOCUS_DELAY_MS = 100; // Delay before adding focus listener
const PRINT_TIMEOUT_MS = 1000; // fallback timeout for print state reset
const PRINT_COLUMNS_WARNING = 'Too many additional columns selected may cause printing issues. Consider reducing columns for better print layout.';
export default {
  __name: 'EntryList',
  props: {
    state: {
      type: Object,
      required: false
    },
    tracking: {
      type: Object,
      required: false
    },
    headers: {
      type: Array,
      required: true
    },
    filter: {
      type: Object,
      required: true
    },
    entryLoading: {
      type: Boolean,
      required: true
    },
    leftPanelOpen: {
      type: Boolean,
      default: false
    },
    rightPanelOpen: {
      type: Boolean,
      default: false
    },
    isPrinting: {
      type: Boolean,
      default: false
    },
    selectedEntryId: {
      type: [String, Number],
      default: null
    },
    toggleStartStopTimes: {
      type: Function,
      required: true
    },
    toggleInternalNotes: {
      type: Function,
      required: true
    },
    toggleTaskCodes: {
      type: Function,
      required: true
    },
    toggleActivityCodes: {
      type: Function,
      required: true
    },
    toggleShortDescriptions: {
      type: Function,
      required: true
    },
    toggleFixedFeeColumn: {
      type: Function,
      required: true
    },
    showLedesCodes: {
      type: Boolean,
      default: false
    }
  },
  emits: ['loadEntries', 'editTimeEntry', 'duplicateEntry', 'closePanels', 'setPrintState', 'triggerPrint', 'closeEditPanel'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      terms,
      permissions,
      features
    } = storeToRefs(useMeStore());
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const entriesStore = useEntriesStore();
    const {
      entries,
      summary,
      pagination
    } = storeToRefs(entriesStore);
    const {
      billingTypeLabel
    } = useBillingTypeLabel();
    const {
      getMattersTable
    } = useClientsMattersStore();
    const {
      matters,
      loadingMatters
    } = storeToRefs(useClientsMattersStore());
    const {
      handleWarning
    } = useSnackbarHandler();
    const {
      exportTimeEntries
    } = useExportUtilities();
    const emit = __emit;

    // ─── Bulk Action Selection State ─────────────────────────────
    const selectedEntryIds = ref([]);

    // Build full entry objects from selected IDs for BulkActionToolbar eligibility
    const selectedEntryObjects = computed(() => {
      if (!selectedEntryIds.value.length) return [];
      const existingEntries = entriesStore.getExistingEntries;
      const idSet = new Set(selectedEntryIds.value);
      return existingEntries.filter(e => idSet.has(e.id));
    });
    const clearSelection = () => {
      selectedEntryIds.value = [];
    };

    // ─── Bulk Operations (shared composable — convert + assign-to-fee) ────
    const {
      bulkOperationLoading,
      billableConfirmRef,
      nonBillableConfirmRef,
      billableConfirmMessage,
      nonBillableConfirmMessage,
      confirmMakeBillable: handleMarkBillable,
      confirmMakeNonBillable: handleMarkNonBillable,
      // Assign to Fixed Fee
      showAssignToFeeModal,
      availableCharges,
      loadingCharges,
      openAssignToFeeModal: handleAssignToFixedFee,
      closeAssignToFeeModal,
      handleAssignToFee,
      // Change Matter dialog state + handlers
      showChangeMatterDialog,
      changeMatterForm,
      openChangeMatterDialog: handleChangeMatter,
      closeChangeMatterDialog: handleChangeMatterCancel,
      handleChangeMatterMatterChange,
      confirmChangeMatter: handleChangeMatterConfirm,
      // Entry process state pass-through
      entryProcessStateMap,
      clearEntryProcessState
    } = useFixedFeeBulkOperations({
      getEntryIds: () => selectedEntryObjects.value.map(e => e.id),
      clearSelection,
      onAfterOperation: () => emit('loadEntries'),
      messageContext: 'this',
      showLargeSelectionWarning: true,
      getMatterId: () => selectedEntryObjects.value[0]?.matter_id || null,
      onTrackConvert: (billingType, convertedCount) => {
        if (props.tracking) {
          const hasAssigned = selectedEntryObjects.value.some(e => e.chargeId);
          const payload = {
            recordsUpdated: convertedCount,
            targetBillingType: billingType,
            detachedFromCharge: hasAssigned,
            pageType: TrackingPageType.TIME_ENTRIES
          };
          EventTracker.trackEvent(props.tracking, TrackingCategory.BULK_UPDATE_TIME, TrackingAction.CONVERT_BILLING_TYPE, payload);
        }
      },
      onTrackAssign: (successCount, targetName, chargeId) => {
        if (props.tracking) {
          const matterId = selectedEntryObjects.value[0]?.matter_id || null;
          const payload = {
            recordsUpdated: successCount,
            chargeId,
            matterId,
            pageType: TrackingPageType.TIME_ENTRIES
          };
          EventTracker.trackEvent(props.tracking, TrackingCategory.BULK_UPDATE_TIME, TrackingAction.ASSIGN_TO_FIXED_FEE, payload);
        }
      },
      onTrackChangeMatter: (successCount, targetMatterId) => {
        if (props.tracking) {
          const sourceMatterId = selectedEntryObjects.value[0]?.matter_id || null;
          const payload = {
            recordsUpdated: successCount,
            sourceMatterId,
            targetMatterId: targetMatterId || null,
            pageType: TrackingPageType.TIME_ENTRIES
          };
          EventTracker.trackEvent(props.tracking, TrackingCategory.BULK_UPDATE_TIME, TrackingAction.CHANGE_MATTER, payload);
        }
      }
    });

    // Use the shared responsive composable
    const {
      isPanelAwareSmallScreen
    } = useResponsiveScreen({
      mobileBreakpoint: 768,
      desktopBreakpoint: 1482,
      heightBreakpoint: 897,
      debounceMs: 100
    });
    const props = __props;
    const vm = reactive({
      loadEntriesTimeout: null,
      page: 1,
      isPrintInProgress: false
    });

    // Computed property to count selected additional columns beyond the base columns
    const selectedColumnsCount = computed(() => {
      // Base columns are always present: Date, Timekeeper, Client/Matter, Hours
      // We count additional optional columns that can be toggled
      let additionalColumns = 0;
      if (props.filter.showStartStopTimes) additionalColumns += 2; // Start Time and Stop Time are 2 separate columns
      if (props.filter.showInternalNotes) additionalColumns++; // Internal Notes column
      if (props.showLedesCodes && props.filter.showTaskCodes) additionalColumns++; // Task Codes column
      if (props.showLedesCodes && props.filter.showActivityCodes) additionalColumns++; // Activity Codes column
      if (features.value?.centralizedFixedFeePage && props.filter.showFixedFeeColumn) additionalColumns++; // Fixed Fee column

      // Note: shortDescriptions doesn't add a column, it just modifies the description display

      return additionalColumns;
    });

    // Computed array of all available columns for the dropdown
    const allColumns = computed(() => [{
      key: 'startStopTimes',
      label: 'Show Start and Stop Times',
      modelValue: props.filter.showStartStopTimes,
      toggleHandler: props.toggleStartStopTimes,
      isVisible: true,
      dataCy: 'checkbox-start-stop-times'
    }, {
      key: 'shortDescriptions',
      label: 'Strip Description Detail',
      modelValue: props.filter.shortDescriptions,
      toggleHandler: props.toggleShortDescriptions,
      isVisible: features.value.stripDescriptions,
      dataCy: 'checkbox-strip-description'
    }, {
      key: 'internalNotes',
      label: 'Show Internal Notes',
      modelValue: props.filter.showInternalNotes,
      toggleHandler: props.toggleInternalNotes,
      isVisible: true,
      dataCy: 'checkbox-internal-notes'
    }, {
      key: 'taskCodes',
      label: 'Task Codes',
      modelValue: props.filter.showTaskCodes,
      toggleHandler: props.toggleTaskCodes,
      isVisible: props.showLedesCodes,
      dataCy: 'checkbox-task-codes'
    }, {
      key: 'activityCodes',
      label: 'Activity Codes',
      modelValue: props.filter.showActivityCodes,
      toggleHandler: props.toggleActivityCodes,
      isVisible: props.showLedesCodes,
      dataCy: 'checkbox-activity-codes'
    }, {
      key: 'fixedFeeColumn',
      label: 'Show Fixed Fee',
      modelValue: props.filter.showFixedFeeColumn,
      toggleHandler: props.toggleFixedFeeColumn,
      isVisible: !!features.value?.centralizedFixedFeePage,
      dataCy: 'checkbox-fixed-fee-column'
    }]);

    // Enabled columns (checked items shown first)
    const enabledColumns = computed(() => allColumns.value.filter(column => column.modelValue && column.isVisible));

    // Disabled columns (unchecked items shown after divider)
    const disabledColumns = computed(() => allColumns.value.filter(column => !column.modelValue && column.isVisible));

    // Check if there are both enabled and disabled items to show the divider
    const hasEnabledItems = computed(() => enabledColumns.value.length > 0 && disabledColumns.value.length > 0);

    // Watch for changes in individual column selections and show warning if > 2 additional columns
    watch(() => [props.filter.showStartStopTimes, props.filter.showInternalNotes, props.filter.showTaskCodes, props.filter.showActivityCodes, props.filter.showFixedFeeColumn], () => {
      if (selectedColumnsCount.value > 2) {
        handleWarning(PRINT_COLUMNS_WARNING);
      }
    }, {
      immediate: false
    });

    // Clear selection when a new data load starts (filter change, pagination, sort, etc.)
    // Skip clearing process state during bulk operations — error icons must remain visible.
    watch(() => props.entryLoading, loading => {
      if (loading) {
        clearSelection();
        if (!bulkOperationLoading.value) {
          clearEntryProcessState();
        }
      }
    });
    watch(() => props.filter.search, () => {
      clearTimeout(vm.loadEntriesTimeout);
      vm.loadEntriesTimeout = setTimeout(() => {
        emit('loadEntries');
      }, 1000);
    });
    watch(() => props.filter.orderBy, () => {
      emit('loadEntries');
    });
    watch(() => props.filter.order, () => {
      emit('loadEntries');
    });
    const editTimeEntry = params => {
      emit('editTimeEntry', params);
    };
    const duplicateEntry = params => {
      emit('duplicateEntry', params);
    };
    const closeEditPanel = entryId => {
      emit('closeEditPanel', entryId);
    };
    const getTotalHours = () => {
      if (!entries.value) return 0;
      return entries.value.reduce((sum, e) => sum + e.hours, 0.0);
    };
    const getTotalAmount = () => {
      if (!entries.value) return 0;
      return entries.value.reduce((sum, e) => sum + e.amount, 0.0);
    };
    const getTotalSummaryHours = () => {
      if (!summary.value) return 0;
      return summary.value.billableHours + summary.value.nonBillableHours + summary.value.fixedFeeHours;
    };
    const printTable = () => {
      // Prevent multiple print calls
      if (vm.isPrintInProgress) {
        return;
      }

      // Show warning if more than 2 additional columns are selected
      if (selectedColumnsCount.value > 2) {
        handleWarning(PRINT_COLUMNS_WARNING);
      }
      vm.isPrintInProgress = true;

      // Close panels first for better print layout
      emit('closePanels');

      // Set printing state
      emit('setPrintState', true);

      // Variables to track listeners and timeout
      let afterPrintListener = null;
      let focusListener = null;
      let timeoutId = null;

      // Function to reset print state and clean up
      const resetPrintState = () => {
        emit('setPrintState', false);
        vm.isPrintInProgress = false;

        // Clean up event listeners
        if (afterPrintListener) {
          window.removeEventListener('afterprint', afterPrintListener);
          afterPrintListener = null;
        }
        if (focusListener) {
          window.removeEventListener('focus', focusListener);
          focusListener = null;
        }

        // Clear timeout
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }
      };

      // Fallback for browsers that don't support afterprint
      const handleFocusReset = () => {
        setTimeout(() => {
          resetPrintState();
        }, PRINT_FOCUS_DELAY_MS);
      };

      // Set up event listeners
      afterPrintListener = resetPrintState;
      focusListener = handleFocusReset;

      // Delay to ensure panels fully close and layout adjusts
      setTimeout(() => {
        // Add event listeners for print completion
        window.addEventListener('afterprint', afterPrintListener);

        // Fallback: reset when window regains focus (print dialog closed)
        setTimeout(() => {
          window.addEventListener('focus', focusListener);
        }, PRINT_FOCUS_DELAY_MS);

        // Ultimate fallback: reset after timeout
        timeoutId = setTimeout(() => {
          if (vm.isPrintInProgress) {
            resetPrintState();
          }
        }, PRINT_TIMEOUT_MS);
        window.print();
      }, PRINT_PANEL_CLOSE_DELAY_MS);
    };
    const exportTable = async () => {
      try {
        await getMattersTable();

        // Fetch ALL entries based on current filters (not just paginated ones)
        const allEntries = await entriesStore.listAllEntriesForExport(props.filter);

        // Validate we have data to export
        if (!allEntries || !allEntries.length) {
          handleWarning('No entries found to export');
          return;
        }
        const customFlag = companySettings.value.labels && companySettings.value.labels.customFlag || false;
        const exportOptions = {
          includeStartEndTimes: props.filter.showStartStopTimes,
          includeRates: permissions.value.time && permissions.value.time.viewRates,
          includeNotes: props.filter.showInternalNotes,
          includeTaskCodes: props.showLedesCodes && props.filter.showTaskCodes,
          includeActivityCodes: props.showLedesCodes && props.filter.showActivityCodes,
          includeFixedFee: !!features.value?.centralizedFixedFeePage && props.filter.showFixedFeeColumn,
          stripDescriptions: props.filter.shortDescriptions,
          customFlag: customFlag,
          terms: terms.value
        };
        await exportTimeEntries(allEntries, matters.value, exportOptions, props.filter);
      } catch (error) {
        console.error('Export failed:', error);
        handleWarning('Failed to export entries. Please try again.');
      }
    };
    const showAllEntries = () => {
      props.filter.limit = pagination.value.total;
      emit('loadEntries');
    };
    const loadEntryBasedOnPage = () => {
      props.filter.offset = (vm.page - 1) * props.filter.limit;
      emit('loadEntries');
    };
    const isSmallScreen = computed(() => {
      return isPanelAwareSmallScreen(props.leftPanelOpen, props.rightPanelOpen);
    });
    const handleTriggerPrint = () => {
      printTable();
    };
    return (_ctx, _cache) => {
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_menu = _resolveComponent("v-menu");
      const _component_v_pagination = _resolveComponent("v-pagination");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(SnackbarComponent, {
        ref: "snackbar"
      }, null, 512), _unref(features)?.centralizedFixedFeePage ? (_openBlock(), _createBlock(ChangeMatterDialog, {
        key: 0,
        modelValue: _unref(showChangeMatterDialog),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(showChangeMatterDialog) ? showChangeMatterDialog.value = $event : null),
        "selected-count": selectedEntryIds.value.length,
        "matter-form": _unref(changeMatterForm),
        "item-label": "time entry",
        "item-label-plural": "time entries",
        onConfirm: _unref(handleChangeMatterConfirm),
        onCancel: _unref(handleChangeMatterCancel),
        onMatterChange: _unref(handleChangeMatterMatterChange)
      }, null, 8, ["modelValue", "selected-count", "matter-form", "onConfirm", "onCancel", "onMatterChange"])) : _createCommentVNode("", true), __props.entryLoading ? (_openBlock(), _createBlock(Loader, {
        key: 1,
        what: 'Entries',
        class: "mt-32"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(LlSearch, {
        modelValue: __props.filter.search,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => __props.filter.search = $event),
        label: "Search Entries"
      }, null, 8, ["modelValue"])]), !__props.entryLoading && _unref(entries).length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(LlSecondaryButton, {
        size: "small",
        onBtnClick: _cache[2] || (_cache[2] = $event => printTable()),
        variant: "outlined",
        class: "w-full sm:w-auto",
        id: "at-print",
        "append-icon": "mdi-printer"
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" Print ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        size: "small",
        onBtnClick: _cache[3] || (_cache[3] = $event => exportTable()),
        isSaving: _unref(loadingMatters),
        variant: "outlined",
        class: "w-full sm:w-auto",
        "append-icon": "mdi-download"
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Export ", -1)]))]),
        _: 1
      }, 8, ["isSaving"])])) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[12] || (_cache[12] = _createTextVNode(" Total: ", -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.hoursDecimal(getTotalSummaryHours())) + "h ", 1), _unref(permissions).time?.viewRates ? (_openBlock(), _createElementBlock("span", _hoisted_9, [_cache[11] || (_cache[11] = _createTextVNode(" / ", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formatCurrency(_unref(summary).totalAmount)), 1)])) : _createCommentVNode("", true)])]), _withDirectives(_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_v_menu, {
        "close-on-content-click": false
      }, {
        activator: _withCtx(({
          props: menuProps
        }) => [_createVNode(LlSecondaryButton, _mergeProps(menuProps, {
          variant: "outlined",
          size: "small",
          class: "text-capitalize flex-shrink-0",
          "append-icon": "mdi-chevron-down",
          "prepend-icon": "mdi-view-column",
          "data-cy": "columns-menu-button"
        }), {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode(" Columns ", -1)]))]),
          _: 1
        }, 16)]),
        default: _withCtx(() => [_createVNode(_component_v_list, {
          density: "compact",
          class: "py-0"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(enabledColumns.value, column => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: column.key
            }, [column.isVisible ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 0
            }, {
              default: _withCtx(() => [_createVNode(LlCheckbox, {
                "model-value": column.modelValue,
                "onUpdate:modelValue": column.toggleHandler,
                label: column.label,
                labelClass: 'text-sm',
                density: "compact",
                "data-cy": column.dataCy
              }, null, 8, ["model-value", "onUpdate:modelValue", "label", "data-cy"])]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)], 64);
          }), 128)), hasEnabledItems.value ? (_openBlock(), _createElementBlock("hr", _hoisted_13)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disabledColumns.value, column => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: column.key
            }, [column.isVisible ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 0
            }, {
              default: _withCtx(() => [_createVNode(LlCheckbox, {
                "model-value": column.modelValue,
                "onUpdate:modelValue": column.toggleHandler,
                label: column.label,
                labelClass: 'text-sm',
                density: "compact",
                "data-cy": column.dataCy
              }, null, 8, ["model-value", "onUpdate:modelValue", "label", "data-cy"])]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)], 64);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        class: "flex-shrink-0",
        variant: "outlined",
        size: "small",
        onClick: _cache[4] || (_cache[4] = _withModifiers($event => showAllEntries(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" Show All ", -1)]))]),
        _: 1
      })]), _createElementVNode("div", {
        class: _normalizeClass(['flex flex-col xs:flex-row items-center gap-1 md:gap-2 mb-2', {
          'mt-7': isSmallScreen.value
        }])
      }, [_createVNode(_component_v_pagination, {
        modelValue: vm.page,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => vm.page = $event),
        length: Math.ceil(_unref(pagination).total / _unref(pagination).limit) || 0,
        "total-visible": 3,
        density: "compact",
        onClick: _cache[6] || (_cache[6] = $event => loadEntryBasedOnPage()),
        "hide-details": "true",
        class: "flex-shrink-0"
      }, null, 8, ["modelValue", "length"])], 2)], 512), [[_vShow, _unref(entries).length && !__props.entryLoading]])], 512), [[_vShow, _unref(summary) && _unref(entries).length && !__props.entryLoading]]), _unref(entriesStore).getNewEntries.length && !__props.entryLoading ? (_openBlock(), _createBlock(EntryTable, {
        key: 0,
        entries: _unref(entriesStore).getNewEntries,
        state: __props.state,
        headers: __props.headers,
        filter: __props.filter,
        newEntries: true,
        "is-printing": __props.isPrinting,
        "selected-entry-id": __props.selectedEntryId,
        "show-ledes-codes": __props.showLedesCodes,
        onEditTimeEntry: editTimeEntry,
        onTriggerPrint: handleTriggerPrint,
        onCloseEditPanel: closeEditPanel,
        "left-panel-open": __props.leftPanelOpen,
        "right-panel-open": __props.rightPanelOpen
      }, null, 8, ["entries", "state", "headers", "filter", "is-printing", "selected-entry-id", "show-ledes-codes", "left-panel-open", "right-panel-open"])) : _createCommentVNode("", true), _unref(features)?.centralizedFixedFeePage && _unref(entriesStore).getExistingEntries.length && !__props.entryLoading ? (_openBlock(), _createBlock(BulkActionToolbar, {
        key: 1,
        "selected-entries": selectedEntryObjects.value,
        disabled: _unref(bulkOperationLoading),
        onAssignToFixedFee: _unref(handleAssignToFixedFee),
        onChangeMatter: _unref(handleChangeMatter),
        onMarkBillable: _unref(handleMarkBillable),
        onMarkNonBillable: _unref(handleMarkNonBillable),
        onClearSelection: clearSelection
      }, null, 8, ["selected-entries", "disabled", "onAssignToFixedFee", "onChangeMatter", "onMarkBillable", "onMarkNonBillable"])) : _createCommentVNode("", true), _createVNode(LlConfirmationDialog, {
        ref_key: "billableConfirmRef",
        ref: billableConfirmRef,
        title: "Make Entries Billable?",
        message: _unref(billableConfirmMessage),
        "toggle-text": "Cancel",
        "confirm-text": "Make Billable",
        "show-warning-icon": false,
        "preserve-newlines": "",
        "data-cy": "make-billable-confirmation"
      }, null, 8, ["message"]), _createVNode(LlConfirmationDialog, {
        ref_key: "nonBillableConfirmRef",
        ref: nonBillableConfirmRef,
        title: "Make Entries Non-Billable?",
        message: _unref(nonBillableConfirmMessage),
        "toggle-text": "Cancel",
        "confirm-text": "Make Non-Billable",
        "show-warning-icon": false,
        "preserve-newlines": "",
        "data-cy": "make-nonbillable-confirmation"
      }, null, 8, ["message"]), _createVNode(LlAssignToFixedFeeModal, {
        modelValue: _unref(showAssignToFeeModal),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _isRef(showAssignToFeeModal) ? showAssignToFeeModal.value = $event : null),
        "fixed-fee-list": _unref(availableCharges),
        loading: _unref(loadingCharges),
        "selected-count": selectedEntryObjects.value.length,
        onConfirm: _unref(handleAssignToFee),
        onCancel: _unref(closeAssignToFeeModal),
        "data-cy": "assign-to-fee-modal"
      }, null, 8, ["modelValue", "fixed-fee-list", "loading", "selected-count", "onConfirm", "onCancel"]), _unref(entriesStore).getExistingEntries.length && !__props.entryLoading ? (_openBlock(), _createBlock(EntryTable, {
        key: 2,
        entries: _unref(entriesStore).getExistingEntries,
        state: __props.state,
        headers: __props.headers,
        filter: __props.filter,
        "is-printing": __props.isPrinting,
        "selected-entry-id": __props.selectedEntryId,
        "show-ledes-codes": __props.showLedesCodes,
        "show-select": !!_unref(features)?.centralizedFixedFeePage,
        "selected-ids": selectedEntryIds.value,
        "entry-process-state": _unref(entryProcessStateMap),
        "onUpdate:selectedIds": _cache[8] || (_cache[8] = $event => selectedEntryIds.value = $event),
        onEditTimeEntry: editTimeEntry,
        onDuplicateEntry: duplicateEntry,
        onTriggerPrint: handleTriggerPrint,
        onCloseEditPanel: closeEditPanel,
        "left-panel-open": __props.leftPanelOpen,
        "right-panel-open": __props.rightPanelOpen,
        "data-cy": "existing-entries-table"
      }, null, 8, ["entries", "state", "headers", "filter", "is-printing", "selected-entry-id", "show-ledes-codes", "show-select", "selected-ids", "entry-process-state", "left-panel-open", "right-panel-open"])) : _createCommentVNode("", true), _unref(entries).length && !__props.entryLoading ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_withDirectives(_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "ft-column ng-animate-disabled medium"
      }, [_createElementVNode("strong", null, "Totals:")], -1)), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.hoursDecimal(getTotalHours())) + " h ", 1), _withDirectives(_createElementVNode("div", {
        class: "ft-column ng-animate-disabled"
      }, _toDisplayString(_ctx.formatCurrency(getTotalAmount())), 513), [[_vShow, _unref(permissions).time?.viewRates]])])], 512), [[_vShow, !_unref(summary)]]), _withDirectives(_createElementVNode("div", _hoisted_18, [_cache[21] || (_cache[21] = _createElementVNode("div", {
        class: "text-uppercase font-weight-500 my-4 text-left"
      }, "SUMMARY", -1)), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_cache[16] || (_cache[16] = _createTextVNode(" Billable Hours: ", -1)), _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.hoursDecimal(_unref(summary).billableHours)), 1)]), _createElementVNode("div", _hoisted_22, [_cache[17] || (_cache[17] = _createTextVNode(" Non-billable Hours: ", -1)), _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.hoursDecimal(_unref(summary).nonBillableHours)), 1)]), _createElementVNode("div", _hoisted_24, [_cache[18] || (_cache[18] = _createTextVNode(" Fixed Fee Hours: ", -1)), _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.hoursDecimal(_unref(summary).fixedFeeHours)), 1)]), _createElementVNode("div", _hoisted_26, [_cache[19] || (_cache[19] = _createTextVNode(" Total Hours: ", -1)), _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.hoursDecimal(getTotalSummaryHours())), 1)]), _withDirectives(_createElementVNode("div", _hoisted_28, [_cache[20] || (_cache[20] = _createTextVNode(" Total Amount: ", -1)), _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.formatCurrency(_unref(summary).totalAmount)), 1)], 512), [[_vShow, _unref(permissions).time?.viewRates]])])], 512), [[_vShow, _unref(summary)]])])) : _createCommentVNode("", true)])), !__props.entryLoading && !_unref(entries).length ? (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[22] || (_cache[22] = [_createElementVNode("h2", {
        class: "text-lg lg:text-xl"
      }, "No matching entries", -1), _createElementVNode("p", {
        class: "text-sm lg:text-base"
      }, " There are no results for your selected date range and filter ", -1)]))])) : _createCommentVNode("", true)], 64);
    };
  }
};